import React from "react";
import "./FavoritesSlotsSection.css";
import { useAppSelector } from "../../../store/hooks/store.hooks";
import { slotsAttributeHelper } from "../../../utils/slotsAttributeHelper";
import { Box } from "@mui/material";
import { SlotCard } from "../SlotCard/SlotCard";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import heart from "../../../assets/icons/menu/heart.svg";
export const FavoritesSlotsSection = () => {
  const { t } = useTranslation();
  const twoItems = useMediaQuery({ maxWidth: 374.98 });
  const threeItems = useMediaQuery({ minWidth: 374.98, maxWidth: 599.98 });
  const fourItems = useMediaQuery({ minWidth: 599.98, maxWidth: 1029.98 });
  const sixItems = useMediaQuery({ minWidth: 1029.98, maxWidth: 1699.98 });
  const eightItems = useMediaQuery({ minWidth: 1699.98 });
  const games = useAppSelector(({ slots }) => slots.favouriteGames);
  return (
    <Box className="lobby-slots-section">
      <Box className="lobby-slots-section__heading">
        <img src={heart} alt={"Favorites"} />
        {t(`main.menuItems.favorites`)}
      </Box>
      <Box
        className={`lobby-slots-section__container ${
          twoItems ? "two-items" : ""
        }${threeItems ? "three-items" : ""}${fourItems ? "four-items" : ""}${
          sixItems ? "six-items" : ""
        }${eightItems ? "eight-items" : ""}`}
      >
        {games.map((game, index) => {
          return (
            <SlotCard
              key={`lobby-slots_${game.id}`}
              cardId={game.id}
              src={game.src}
              title={game.title}
              top={game.top}
              recs={game.recs}
              new={game.new}
              live={game.live}
              disabled={game.disabled}
              favorites={games}
            />
          );
        })}
      </Box>
    </Box>
  );
};
